import './fontawesome';

import {
  cilApplicationsSettings,
  cilSpeedometer,
  cilSun,
  cilMoon,
  cilUser,
  cilLockLocked,
  cilAccountLogout,
  cilGroup,
  cilSpreadsheet,
  cilBriefcase,
  cilX,
  cilDollar,
  cilAddressBook,
  cilImage,
  cilFile,
  cilSearch,
  cilFrown,
  cilEyedropper,
  cilChevronBottom,
  cilChevronTop,
  cilHospital,
  cilFolderOpen,
  cilChartPie,
  cilFilter,
  cilChartLine,
  cilOptions,
  cilSettings,
  cilMoney,
} from '@coreui/icons';

export const icons = Object.assign(
  {},
  {
    cilApplicationsSettings,
    cilSpeedometer,
    cilSun,
    cilMoon,
    cilUser,
    cilLockLocked,
    cilAccountLogout,
    cilGroup,
    cilBriefcase,
    cilSpreadsheet,
    cilX,
    cilDollar,
    cilAddressBook,
    cilImage,
    cilFile,
    cilSearch,
    cilFrown,
    cilEyedropper,
    cilChevronBottom,
    cilChevronTop,
    cilHospital,
    cilFolderOpen,
    cilChartPie,
    cilFilter,
    cilChartLine,
    cilOptions,
    cilSettings,
    cilMoney,
  }
);
